export default __webpack_public_path__ + "static/media/edition-jw-1-rot-wax-2.150b7cca.svg";